module.exports = __webpack_public_path__ + "static/media/1-en.6c5930f0.svg";